import styled from "styled-components"

import { WIDTH_BREAKPOINTS } from "../../components/globalStyles"
// FIXME: Utilizar componentes do Antd para layout
export const UploadButtons = styled.div`
  display: flex;
  justify-content: center;
  align-content: space-between;
  flex-direction: row;
  @media only screen and (max-width: ${WIDTH_BREAKPOINTS.lg}) {
    flex-direction: column;
    align-items: center;
  }
`
